import React from "react";
import leftArrow from "../assets/images/vuesax_linear_arrow_left.svg";
import clockSvg from "../assets/images/time_clock.svg";
import SliceSvg from "../assets/images/slice_92.svg";
import { SlIcon } from "@shoelace-style/shoelace/dist/react";
import CreativeNameDisplay from "../shared/CreativeNameDisplay";
function BrandAdImagePreview({ preview }) {
  // const handleClick = () => { };
  //   const componentId = useSelector(state => state.Head.component_id)

  //   const handleDownloadPreview = () => {
  //     const previewElement = document.querySelector('.download-preview');
  //     toBlob(previewElement).then(function (blob) {
  //       saveAs(blob, `${preview.name}.png`);
  //     });
  //   };
  return (
    <>
      wwswwswswswsww
      <div className="download-preview">
        <CreativeNameDisplay preview={preview} />
        <div className="preview-inner">
          {/* <div className="preview-full-image"> */}
          {preview.sub_type === "unread" && (
            <div className="h-full">
              <div className="min-h-[60%] bg-gray-100 rounded-t-[24px] d-flex flex-col justify-end">
                <div>
                  {preview.img_urls && <img src={preview.img_urls} alt="ad" />}
                </div>
              </div>
              <div className="bg-white min-h-[40%] rounded-b-[24px] p-3 text-center py-6">
                <p className="text-sm">Loading</p>
                <h2 className="font-black">చదవని వార్తలు</h2>
                <h5 className="font-bold">Stories</h5>
                <div className="d-flex gap-2 my-[24px] justify-center">
                  <span className="w-2 h-2 rounded-full bg-gray-300"></span>
                  <span className="w-2 h-2 rounded-full bg-black"></span>
                  <span className="w-2 h-2 rounded-full bg-gray-300"></span>
                </div>
                <p className="text-sm">
                  Please wait while we are
                  <span>
                    <br />
                  </span>
                  searching for stories
                </p>
              </div>
            </div>
          )}
          {preview.sub_type === "search" && (
            <div className="h-full">
              <div className="min-h-[16%] bg-[#258AFE] rounded-t-[24px]">
                <div className="d-flex gap-1 items-center">
                  <img src={leftArrow} alt="backarrow" />
                  <p className="text-white fw-bold p-0 m-0">Back</p>
                </div>
                <div className="px-5 relative">
                  <input
                    className="form-control h-9"
                    placeholder="సెర్చ్ చెయ్యండి"
                  />
                  <span className="absolute top-[0.6rem] right-[2rem]">
                    <SlIcon library="lucide" name="search" />
                  </span>
                  <p className="text-[9px]  text-white my-1 p-0">
                    Search keywords as: Modi, Politics, Health, Stocks
                  </p>
                </div>
              </div>
              <div className="min-h-[4%] bg-[#FFF1C2] d-flex gap-3 px-5 items-center">
                <img src={SliceSvg} alt="sliceSvg" />
                <h6 className="text-black p-0 text-xs">No Stories Found</h6>
              </div>
              <div className="px-7">
                <div className="d-flex gap-2 items-center mt-4">
                  <div>
                    <img src={clockSvg} alt="clock-icon" />
                  </div>
                  <div>
                    <p className="p-0 m-0 text-[10px] text-gray-500">
                      Select Stories Before
                    </p>
                    <p className=" p-0 m-0 fw-bold text-gray-400">
                      Between last 24 hours
                    </p>
                  </div>
                </div>
                <div className="d-flex flex-col gap-2 my-4">
                  <div className="d-flex gap-3">
                    <span className="px-3 py-[6px] border-[1px] text-xs fw-bold rounded-full">1 hour</span>
                    <span className="px-3 py-[6px] border-[1px]  text-xs fw-bold rounded-full">2 hours</span>
                    <span className="px-3 py-[6px] border-[1px]  text-xs fw-bold rounded-full">4 hours</span>
                  </div>
                  <div className="d-flex gap-3">
                    <span className="px-3 py-[6px] border-[1px]  text-xs fw-bold rounded-full">8 hours</span>
                    <span className="px-3 py-[6px] border-[1px]  text-xs fw-bold rounded-full">12 hours</span>
                    <span className="px-3 py-[6px] border-[1px]  text-xs fw-bold rounded-full">16 hours</span>
                  </div>
                  <div className="d-flex gap-3">
                    <span className="px-3 py-[6px] border-[1px]  text-xs fw-bold rounded-full">20 hours</span>
                    <span className="px-3 py-[6px] border-[1px]  text-xs fw-bold rounded-full">24 hours</span>
                  </div>
                </div>
                <div>
                  {preview.img_urls && <img src={preview.img_urls} alt="ad" />}
                </div>
              </div>
            </div>
          )}
          {/* </div> */}
        </div>
      </div>
    </>
  );
}

export default BrandAdImagePreview;
